export default __webpack_public_path__ + "static/media/imgs3.9fc9a4b0.jpg";